import { React } from '../../Imports';
import * as _ from 'lodash';

interface IVideoEventIdProps {
    displayEventId?: string;
    type?: 'detailsRecall';
}

const styles = require('./VideoEventIdLabel.scss') as {
    labelEventId: string;
    size: string;
    recallSize: string;
    labelFormat: string;
};

type VideoEventIdProps = IVideoEventIdProps;

export const VideoEventIdLabel = ({ displayEventId, type }: VideoEventIdProps) => {
    return (
        <label className={`${styles.labelEventId} ${type ? styles.recallSize : styles.labelFormat}`}>
            <span>
                ID: <b>{displayEventId}</b>
            </span>
        </label>
    );
};
